import React, {useContext, useEffect, useCallback} from 'react'
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from '@material-ui/core'
import fixture from './../../../fixtures/reservations/additional-fields-wizard.json'
import WizardAdditionalFields from './../CustomComponents/WizardAdditionalFields'
import WSearchList from '../../ReservationReserve/CustomComponents/WizardAdditionalFields/WSearchList'
import {ReservationContext} from './../../../context/Reservation'
import moment from 'moment'
import {config} from 'process'
import _ from 'lodash'

export default function StepSelectAdditionalFields() {
  const {configuration, reservation, update, loadConfiguration} = useContext(ReservationContext)

  const getUpdatedAdditionalFields = useCallback((configData, realData) => {
    let op = []
    configData.forEach(cField => {
      realData.forEach(rField => {
        if (cField?.id === rField?.field_id || cField?.id === rField?.id) {
          if (cField.type === 'MultipleEntityListField' || cField.type === 'MultipleListField') {
            op.push({
              ...cField,
              value: _.isArray(rField?.value) ? rField.value : rField?.value?.split('!#!') || [],
            })
          } else {
            op.push({...cField, value: rField.value || ''})
          }
        }
      })
    })
    return op
  }, [])

  //eslint-disable-nextline
  useEffect(() => {
    loadConfiguration(reservation?.selected_group?.id)
    if (configuration?.data?.additional_fields && !reservation?.additional_fields?.length) {
      update('additional_fields', configuration?.data?.additional_fields)
    } else if (
      configuration.data?.additional_fields.length &&
      reservation?.additional_fields?.length &&
      reservation?.is_edit
    ) {
      update(
        'additional_fields',
        getUpdatedAdditionalFields(
          configuration?.data?.additional_fields,
          reservation?.additional_fields
        )
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChange = (e, key, value, i) => {
    let _additional_fields = reservation.additional_fields.map(af => {
      if (value.key === af.key) {
        if (value.type === 'DateTimeField') {
          if (e !== null) {
            if (e?.target?.value) {
              af[key] = moment(e?.target?.value)
                .local()
                .format('YYYY-MM-DD HH:mm:ss')
            } else {
              af[key] = moment(e?._d)
                .local()
                .format('YYYY-MM-DD HH:mm:ss')
            }
          } else {
            af[key] = ''
          }
        } else {
          af[key] = e !== null ? e.target?.value : ''
          if (i) {
            af['value_name'] = af['value_name']
              ? af['value_name'].match(i.props.children)
                ? `${af.value_name.replace(i.props.children, '')}`
                : `${af.value_name}, ${i.props.children}`
              : i.props.children
          }
        }
      }
      return af
    })
    update('additional_fields', _additional_fields)
  }
  return (
    <div className="ap-scrollbar" style={{height: 475, overflowY: 'auto'}}>
      <Typography className="ap-typography ap-typography--lg">Fill in additional fields</Typography>
      <Grid container style={{marginTop: 30}}>
        {reservation.additional_fields?.map(field => {
          return (
            <Grid item xs={6} style={{marginTop: 32}}>
              {field.type === 'EntityListField' ? (
                <WSearchList
                  onChange={e => {
                    onChange(e, field.id, field.type)
                  }}
                  data={field}
                  fieldType={field.type}
                  fieldId={field.id}
                />
              ) : (
                <WizardAdditionalFields
                  onChange={onChange}
                  data={field}
                  fieldType={field.type}
                  fieldId={field.id}
                />
              )}
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}
